import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    paddingBottom: '8rem',

    min1024: {
        paddingBottom: 0,
    },
});
